import { reportRaptorMetrics } from '@/src/common/SLRaptor';
import { reportCodeTryException } from '@/src/common/exception';
import { callModule } from '../market/util';
import { notiSkyTraffichavenFinish } from '../market';
import { TraffichavenStatus, getTraffichavenStatus, setupTraffichavenStatus } from './util';

const SLCommon = Mach.requireModule('SLCommon');
const Horn = Mach.requireModule('SLCHorn');
const Login = Mach.requireModule('Login');
const SLTraffichaven = Mach.requireModule('SLTraffichaven');
const WMToast = Mach.requireModule('Toast');

Mach.on('homepage_popup_to_worker', (data) => {
  return; //去掉worker中拉承一体的监听，在客户端合并处理请求
  console.log('拉承一体 [event homepage_popup_to_worker]:', data);

  const gTraffichavenStatus = getTraffichavenStatus();
  if ((TraffichavenStatus.FINISH == gTraffichavenStatus) || (TraffichavenStatus.LOADING == gTraffichavenStatus)) {
    return;
  }
  // 加载中
  setupTraffichavenStatus(TraffichavenStatus.LOADING);

  if (Mach.env.isAndroid) {
    getAndroidFirebaseId();
    getAndroidGaid();
  } else {
    traffichavenData(SLCommon.firebaseId?.());
  }
});

// 安卓需要特殊处理, 因为是异常获取的
const kAndroidDefaultConst = '-999999kAndroidDefaultConst';
let androidFirebaseId = kAndroidDefaultConst;
let androidGaid = kAndroidDefaultConst;
function getAndroidFirebaseId() {
  SLCommon.firebaseId?.((result) => {
    androidFirebaseId = result?.firebaseId || '';
    traffichavenData(androidFirebaseId, androidGaid);
  });
}

function getAndroidGaid() {
  SLCommon.gaid?.((result) => {
    androidGaid = result?.gaid || '';
    traffichavenData(androidFirebaseId, androidGaid);
  });
}

// 获取对应的 拉承一体 数据
function traffichavenData(firebaseId: string, gaid?: string) {
  if ((firebaseId === kAndroidDefaultConst) || (gaid === kAndroidDefaultConst)) {
    // 说明 安卓的这两个值还没回来
    console.log('安卓的这两个值还没回来, firebaseId:', firebaseId, 'gaid:', gaid);
    return;
  }

  const userPositionReq = getLatLng();

  // 粘贴板的内容
  let pasteboardContent = '';

  // horn 开关是否打开
  const marketingTraffichavenSwitch = Horn?.getAppConfigForKey('marketingTraffichavenSwitch') === true;
  if (marketingTraffichavenSwitch) {
    // 读取粘贴板的内容
    pasteboardContent = (SLCommon.pasteboardContent?.() || '');
  }

  const SLADJust = Mach.requireModule('SLADJust');
  const param = {
    firstOpenFlag: getFirstOpenFlag(),
    pasteboardContent,
    deviceReq: {
      adid: SLADJust.adid?.(),
      gaid: (gaid || ''),
      frid: firebaseId,
      idfa: (SLCommon.idfa?.() || '')
    },
    userPositionReq
  };
  requestData(param)
    .then((result) => {
      if (result?.showContent) {
        console.log('result: ', result);
        pageJump(result.showContent);
      } else {
        console.log('result error: ', result);
        reportMetrics('empty', (result?.message || result?.msg || 'api error'));
      }
      noti_sky_popup(!!result?.showContent);
    })
    .catch((error) => {
      console.log('error: ', error);
      noti_sky_popup(false);
    });
}

// 通知 天降弹窗 可以弹出来了
function noti_sky_popup(delay: boolean) {
  setupTraffichavenStatus(TraffichavenStatus.FINISH);
  if (delay) {
    setTimeout(() => {
      notiSkyTraffichavenFinish();
    }, 100);
  } else {
    notiSkyTraffichavenFinish();
  }
}

/*
** 拉承一体
*/
async function requestData(data): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = 'v1/traffichaven/guide';
  const params = {
    url,
    method: 'POST',
    params: null,
    data,
    dataType: 'json',
  };
    // @ts-ignore
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      console.log('requestWx result: ', result);
      if (result?.error) {
        reject(result.error);
      } else {
        if (result?.data && result?.data?.code == 0 && result?.data?.data) {
          resolve(result.data.data);
        } else {
          if (result && result.error) {
            reportMetrics('api', 'error');
          } else if (result && result.data) {
            const msg = result?.data?.message || result?.data?.msg || 'other error';
            reportMetrics('api', msg, (result?.data?.code || '-0'));
          }
          const msg = result && result?.data && result?.data?.message && result?.data?.msg;
          reject(msg);
        }

        // 成功之后, 将是否首次设置成非首次
        setFirstOpenFlagStorage();
      }
    });
  });
}

// 获取经纬度
const getLatLng = () => {
  const SLLocation = Mach.requireModule('SLLocation');
  const location = SLLocation?.getLocation() || {};
  return {
    latitude: location?.latitude,
    longitude: location?.longitude,
    actualLatitude: location?.actualLatitude,
    actualLongitude: location?.actualLongitude,
  };
};

const _kFirstOpenFlagKey = '_kFirstOpenFlagKey';
let firstOpenFlag: any = '-1';
function getFirstOpenFlag() {
  if (firstOpenFlag === '-1') {
    const value = SLCommon?.getStorage?.({
      key: _kFirstOpenFlagKey
    });

    firstOpenFlag = !value;
  }
  return firstOpenFlag;
}

function setFirstOpenFlagStorage() {
  if (firstOpenFlag) {
    SLCommon?.setStorage?.({
      key: _kFirstOpenFlagKey,
      value: 'value'
    });

    firstOpenFlag = false;
  }
}

function pageJump(showContent: string) {
  callModule(
    'Router',
    'navigateTo',
    (result) => {
      if (!result.success) {
        console.log(
          'navigate error ~~~~'
        );
        reportMetrics('jump', showContent || 'navigate error');
      }
    },
    showContent,
    {}
  );
}

// 监控上报
function reportMetrics(type: 'jump'| 'empty' | 'api', message: string, code?: any) {
  reportRaptorMetrics({
    machTraffichavenError: 1
  }, {
    type,
    message,
    code: (code || '-1')
  });
}

// 请求拉承一体
function requestTraffichaven() {
  // 获取当前的页面, 延迟3s后再返回获取的当前页面
  SLCommon?.curPage?.({
    type: 'eventOfLogin',
    delay: 3
  }, (result) => {
    const curPage = result.content;
    console.log('当前页面: ', curPage);

    // 拉承一体跳转页面配置
    const traffichavenPages: string[] = Horn?.getAppConfigForKey('traffichavenPages') || ['homepage', 'mach_pro_sailor_c_home_page_main'];
    console.log('traffichavenPages', traffichavenPages);
    if (traffichavenPages.includes(curPage)) {
      // 调用拉承一体服务
      SLTraffichaven?.request?.();

      // 统计 触发的用户
      reportRaptorMetrics({
        slTraffichavenAppFirstOpen: 1
      }, {});
    }
  });
}

// 是否调用过拉承一体
let requestTraffichavenCalled = false;

// 监听登录成功，判断是否调研拉承一体服务
const eventOfLogin = Login?.eventOfLogin();
Mach.requireModule('EventCenter').addListener(eventOfLogin, () => {
  try {
    const isAppFirstOpen = SLCommon?.isAppFirstOpen?.() || false;
    console.log('登录成功了, ', isAppFirstOpen);
    if (isAppFirstOpen && !requestTraffichavenCalled) {
      // 首次安装最新包, 首次启动
      requestTraffichaven();
      // 标识已经调用了
      requestTraffichavenCalled = true;
    }
  } catch (error) {
    console.log(error);
    // 捕获到异常上报
    reportCodeTryException({
      message: 'requestTraffichaven',
      extra: error
    });
  }
});
